import {NavLink} from 'react-router-dom';


function PublicNavigation() {

  return (
    <header className="header">
      <nav>
        <ul className="list">
          <li>
            <a 
              href="https://www.billfishpachanga.com/" 
              className={ ({isActive}) => isActive ? "active" : undefined} 
            >
              Home
            </a>
          </li>
          <li>
            <NavLink 
              to="/" 
              className={ ({isActive}) => isActive ? "active" : undefined} 
            >
              Register
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/public/results" 
              className={ ({isActive}) => isActive ? "active" : undefined} 
            >
              Results
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/public/catches" 
              className={ ({isActive}) => isActive ? "active" : undefined} 
            >
              Catches
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/public/fishpots" 
              className={ ({isActive}) => isActive ? "active" : undefined} 
            >
              Fish Pots
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/public/slideshow" 
              className={ ({isActive}) => isActive ? "active" : undefined} 
            >
              Slideshow
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/login" 
              className={ ({isActive}) => isActive ? "active" : undefined} 
            >
              Login
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default PublicNavigation;

